// Envía el token de sesión en todas las peticiones a los backends del portal y, si alguno
// responde 401 (sin sesión o caducada), cierra la sesión y vuelve al login.
// Si una lectura falla porque el portal externo (Quesos) no responde, lo avisa una vez.
import axios from "axios";
import { avisar } from "./dialogos";

const API = process.env.VUE_APP_LOCAL_BASE_URL;
// varias lecturas fallan a la vez cuando el portal está caído: un solo aviso cada tanto
const PAUSA_AVISO_PORTAL_MS = 15000;
let ultimoAvisoPortal = 0;

function esPeticionAlPortal(url = "") {
  return url.startsWith("/") || (API && url.startsWith(API));
}

export function instalarSesionAxios({ store, router }) {
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token && esPeticionAlPortal(config.url)) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const esLogin = (error.config?.url || "").includes("/portal/login/");
      if (status === 401 && !esLogin && router.currentRoute.name !== "login") {
        store.dispatch("logout");
        router.push({ name: "login" }).catch(() => {});
      }
      // las escrituras ya muestran el error del servidor en su pantalla
      const esLectura = (error.config?.method || "get").toLowerCase() === "get";
      if (status === 504 && esLectura && error.response?.data?.origen === "externo_error" && Date.now() - ultimoAvisoPortal > PAUSA_AVISO_PORTAL_MS) {
        ultimoAvisoPortal = Date.now();
        avisar(error.response.data.error, "warning");
      }
      return Promise.reject(error);
    }
  );
}

/**
 * Descarga un archivo de la API con la sesión (no se puede con window.open ni <img src>,
 * que no envían el token) y devuelve una URL local (blob:) para mostrarlo o descargarlo.
 * Quien la use debe liberarla con URL.revokeObjectURL cuando ya no la necesite.
 */
export async function urlBlobConSesion(url) {
  const { data } = await axios.get(url, { responseType: "blob" });
  return URL.createObjectURL(data);
}
